import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Icon } from 'rsuite'
import { Container, Content } from 'rsuite'

export default function TableBackList({ schema, header }) {
  const chkStatusBackList = (status) => {
    let _style = {}
    if (status === 'ไม่ได้อยู่ในรายชื่อแบล็คลิส') {
      _style.color = '#2da888'
      _style.icon = 'ok-circle'
    } else {
      _style.color = '#fb8a81'
      _style.icon = 'warning'
    }

    return (
      <ControlLabel style={{ color: _style.color, fontWeight: 'bold' }}>
        <Icon icon={_style.icon} size="2x" style={{ paddingRight: 5 }} />
        {status}
      </ControlLabel>
    )
  }

  return (
    <>
      <Panel header={header} bordered bodyFill collapsible style={{ marginTop: 0 }} defaultExpanded>
        <Container className="table-black-list__container">
          <Content className="table-black-list__ccontent">
            <Row style={{ padding: '15px' }}>
              <Col xs={18} sm={19} md={24}>
                <strong>{schema.statusTitle} : </strong>
                {/* {schema.status} */}
                {chkStatusBackList(schema.status)}
              </Col>
            </Row>
          </Content>
        </Container>
      </Panel>
    </>
  )
}
